module.exports = __webpack_public_path__ + "img/49_4.1afe35fa.png";